var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside_menu"},[_c('ul',{staticClass:"list_aside"},_vm._l((_vm.menu),function(item){return _c('li',{key:item.txt,class:{
        on: _vm.router.currentRoute.path.includes(item.name)
      }},[_c('router-link',{attrs:{"to":{ path: item.link }}},[_vm._v(_vm._s(item.txt))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }